// Copyright (c) 2023 Deere & Company

import {combineReducers} from 'redux';
import duplicatePinPlate from './duplicate-pin-plate';
import formValidation from './form-validation';
import isValid from './validate-pin';
import temporaryObjectKey from './temporary-object-key';

export const getCombinedReducers = () => combineReducers({
    duplicatePinPlate,
    formValidation,
    isValid,
    temporaryObjectKey
});



// WEBPACK FOOTER //
// ./src/product/duplicate-pin-plate/reducers/index.js